module.exports = __webpack_public_path__ + "static/media/approve.761e874a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/approve.svg
// module id = 179
// module chunks = 36